import { RoutineColors } from "@/utilities/routineColors";
import type { Routine } from "instantdb/types";

export const NUTRITION_ROUTINES: Partial<Routine>[] = [
  {
    id: "balanced-meal-planning",
    title: "Balanced Meal Planning",
    symbol: "🍽️",
    description: "Create nutritious and satisfying meals for the week",
    dailyRoutine: false,
    selectedDays: [{ day: "sunday", datetime: "16:00:00.000Z" }],
    color: RoutineColors[3].value,
    steps: [
      {
        id: "review-nutritional-needs",
        title: "Review nutritional needs",
        description: "Consider your dietary requirements and health goals",
      },
      {
        id: "plan-balanced-meals",
        title: "Plan balanced meals",
        description: "Design meals with proteins, whole grains, and plenty of vegetables",
      },
      {
        id: "create-shopping-list",
        title: "Create shopping list",
        description: "List ingredients needed for your planned meals",
      },
    ],
  },
  {
    id: "mindful-eating-practice",
    title: "Mindful Eating Practice",
    symbol: "🍽️",
    description: "Develop awareness while eating to improve digestion and satisfaction",
    dailyRoutine: true,
    selectedDays: [],
    color: RoutineColors[4].value,
    steps: [
      {
        id: "prepare-your-environment",
        title: "Prepare your environment",
        description: "Remove distractions like phones and TV during meals",
      },
      {
        id: "engage-your-senses",
        title: "Engage your senses",
        description: "Notice the colors, smells, and textures of your food",
      },
      {
        id: "eat-slowly",
        title: "Eat slowly",
        description: "Chew thoroughly and pause between bites to savor your food",
      },
    ],
  },
  {
    id: "hydration-schedule",
    title: "Hydration Schedule",
    symbol: "💧",
    description: "Maintain proper hydration throughout the day",
    dailyRoutine: true,
    selectedDays: [],
    color: RoutineColors[5].value,
    steps: [
      {
        id: "morning-hydration",
        title: "Morning hydration",
        description: "Drink a glass of water upon waking",
      },
      {
        id: "regular-water-breaks",
        title: "Regular water breaks",
        description: "Drink water before and between meals throughout the day",
      },
      {
        id: "evening-hydration",
        title: "Evening hydration check",
        description: "Assess your water intake and have a final glass before bed",
      },
    ],
  },
];
